import { localContentPrefix } from '../../../../config';
import { http } from '../../../../api/axios';

export const addLibxProductToCollection = (productId: string): Promise<void> => {
    return http.post(
        `${localContentPrefix}/v1/localcollectioncontent/:id/add`,
        {},
        {
            pathParams: { id: productId }
        }
    );
};
